export default __webpack_public_path__ + "static/manling-cc288d43dda6a7c90f0c7b109e9cbd37.jpg";